import { render, staticRenderFns } from "./form_copy.vue?vue&type=template&id=c2fddcdc&scoped=true"
import script from "./form_copy.vue?vue&type=script&lang=js"
export * from "./form_copy.vue?vue&type=script&lang=js"
import style0 from "./form_copy.vue?vue&type=style&index=0&id=c2fddcdc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fddcdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2fddcdc')) {
      api.createRecord('c2fddcdc', component.options)
    } else {
      api.reload('c2fddcdc', component.options)
    }
    module.hot.accept("./form_copy.vue?vue&type=template&id=c2fddcdc&scoped=true", function () {
      api.rerender('c2fddcdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/contract/form/form_copy.vue"
export default component.exports